import {useEffect, useRef, useState} from "react";
import s from "./ReviewCarousel.module.scss";
import ReviewCard from "../../../components/ReviewCard/ReviewCard";
import LoadMoreButton from "../../../components/LoadMoreButton/LoadMoreButton";
import {useNavigate} from "react-router-dom";
import titleImage from "../../../assets/images/titleImage.png";
import axios from "axios";
import api from "../../../api/client";

const ReviewCarousel = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    const apiUrl = process.env.REACT_APP_API_URL;

    const navigate = useNavigate();

    const breadcrumbItems = [
        { name: 'ホーム', link: '/' },
        { name: 'レビュー一覧', link: '' },
    ];
    const safeReviews = Array.isArray(reviews) ? reviews : [];

    const containerRef = useRef();
    const [itemsPerView, setItemsPerView] = useState(2);
    const [index, setIndex] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const startXRef = useRef(0);
    useEffect(() => {
        const fetchLatestReviews = async () => {
            try {
                const response = await api.get(
                    `/api/reviews/latest`
                );

                setReviews(response.data.latestReviews || []);
            } catch (error) {
                console.error("Failed to load reviews", error);
                setReviews([]);
            } finally {
                setLoading(false);
            }
        };

        fetchLatestReviews();
    }, []);
    // ✅ Responsive
    useEffect(() => {
        const handleResize = () => {
            setItemsPerView(window.innerWidth < 768 ? 1 : 2);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setIndex(0);
    }, [itemsPerView]);

    // ✅ Infinite loop setup
    const extended = [
        ...safeReviews.slice(-itemsPerView),
        ...safeReviews,
        ...safeReviews.slice(0, itemsPerView),
    ];

    // ✅ Reset logic
    useEffect(() => {
        const total = safeReviews.length;

        if (total === 0) return; // ✅ VERY IMPORTANT

        if (index === total) {
            setTimeout(() => {
                if (!containerRef.current) return;

                containerRef.current.style.transition = "none";
                setIndex(0);

                void containerRef.current.offsetHeight;

                containerRef.current.style.transition = "transform 0.5s ease";
            }, 500);
        }

        if (index === -1) {
            setTimeout(() => {
                if (!containerRef.current) return;

                containerRef.current.style.transition = "none";
                setIndex(total - 1);

                void containerRef.current.offsetHeight;

                containerRef.current.style.transition = "transform 0.5s ease";
            }, 500);
        }
    }, [index, safeReviews.length]);

    const handleNext = () => setIndex(prev => prev + 1);
    const handlePrev = () => setIndex(prev => prev - 1);

    // ✅ Drag
    const onStart = (e) => {
        setIsDragging(true);
        startXRef.current = e.touches ? e.touches[0].clientX : e.clientX;
    };

    const onEnd = (e) => {
        if (!isDragging) return;
        setIsDragging(false);

        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const diff = startXRef.current - endX;

        if (Math.abs(diff) > 50) {
            diff > 0 ? handleNext() : handlePrev();
        }
    };

    const handleLoadMore = () => {
        navigate('/reviews', { state: { breadcrumbItems } });
    };
    if (!safeReviews.length) return null;

    return (
        <div className={"row mt-5 mb-3"}>
            <div className={"col-12"}>
                <div className={s.titleWrrapper}>
                    <img className={s.titleImage} src={titleImage}/>
                    <h2 className={s.primaryTitle}>新着口コミ</h2>
                    <h3 className={s.secondaryTitle}>Reviews</h3>

                </div>
            </div>

            <div className={"col-12 "}>
                <div className={"d-flex  justify-content-end"}>

                    <LoadMoreButton onClick={handleLoadMore} label="もっと見る"/>
                </div>
            </div>
            <div className={"col-12"}>
                <div className={s.carousel}>
                    <div
                        className={s.inner}
                        ref={containerRef}
                        style={{
                            transform: `translateX(-${(index * 100) / itemsPerView}%)`,
                            transition: isDragging ? "none" : "transform 0.5s ease"
                        }}
                        onMouseDown={onStart}
                        onMouseUp={onEnd}
                        onTouchStart={onStart}
                        onTouchEnd={onEnd}
                    >
                        {extended.map((review, i) => (
                            <div
                                key={i}
                                className={s.item}
                                style={{flex: `0 0 ${100 / itemsPerView}%`}}
                            >
                                <ReviewCard key={index}
                                            title={review.tour.title}
                                            rezdyId={review.tour.rezdyId}
                                            tourId={review.tour.tourId}
                                            stars={review.rating}
                                            date={review.date}
                                            userType={review.attribute}
                                            userName={review.name}
                                            review={review.body}
                                            thumb={review.tour.image}/>
                            </div>
                        ))}
                    </div>

                    {/* Buttons */}
                    <button className={s.prev} onClick={handlePrev}>‹</button>
                    <button className={s.next} onClick={handleNext}>›</button>
                </div>
            </div>
        </div>
    );
};

export default ReviewCarousel;